/* Beneos guide deep-link.
   Pre-filters the PUBLIC library browser (#library-search) from URL params so a blog
   image or CTA can land a visitor on exactly the relevant maps. Non-invasive: it drives
   the existing public search UI (data-ls-search / .exp-tab / data-ls-access) via simulated
   input and clicks. It does NOT touch the search engine internals (beneos-search.js).
   Supported params: ?q=<text>  ?kind=battlemap|token|item|spell  ?access=all|free
   It waits until the library has finished loading before applying, otherwise the value
   gets reset by the browser's own first render. */
(function () {
  var p = new URLSearchParams(location.search);
  var q = p.get('q');
  var kind = p.get('kind');
  var access = p.get('access');
  if (!q && !kind && !access) return;
  var root = document.getElementById('library-search');
  if (!root) return;

  /* Fertig ist der Browser, wenn im Ergebnisbereich eine erste Karte steht.
     Vorher wurde auf das Wort "of" im Zaehler geprueft, und das ist nur auf
     Englisch da: die deutsche Fassung schreibt "24 von 2.093 angezeigt". Am
     2026-08-17 auf /de gemessen: der Vorfilter lief 140 Versuche lang leer und
     gab auf, die Bibliothek zeigte alle 2.093 Eintraege. Betroffen war jeder
     Verweis mit ?q= in allen zwoelf uebersetzten Sprachen.
     render() in beneos-home.js:444 fuellt [data-ls-results], bevor es den
     Zaehler schreibt. Ein Kind dort ist damit dasselbe Signal, nur ohne
     Sprache. */
  function loaded() {
    var r = root.querySelector('[data-ls-results]');
    return r && r.children.length > 0 && root.querySelector('[data-ls-search]');
  }
  function waitLoaded(cb, n) {
    n = n || 0;
    if (loaded()) { cb(); return; }
    if (n > 140) return;
    setTimeout(function () { waitLoaded(cb, n + 1); }, 150);
  }
  function applyQ() {
    var input = root.querySelector('[data-ls-search]');
    if (access) {
      var ab = root.querySelector('[data-ls-access] [data-access="' + access + '"]');
      if (ab && !ab.classList.contains('is-active')) { ab.click(); }
    }
    if (q && input) {
      input.value = q;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }
  function run() {
    if (kind) {
      var tab = root.querySelector('.exp-tab[data-kind="' + kind + '"]');
      if (tab && !tab.classList.contains('is-active')) {
        tab.click();
        waitLoaded(applyQ); // the new kind loads its own data, wait again
        return;
      }
    }
    applyQ();
  }
  waitLoaded(run);
})();
